import React, { Component } from 'react';
import LayoutPages from '../../Components/LayoutPages';
import { List, Tag, Modal, Icon, Button } from 'antd';
import UserProvider from '../../js/userProvider';
import DataService from '../../Components/Data';

import './Documentos.css';

class Documentos extends Component {

    constructor(props) {
        super(props);

        this.state = {
            modalObservacaoShow: false,
            modalObservacaoText: "",
            loading: false,
            dadosTabelaDocumentos: []
        };

        this.dataService = new DataService();
        this.dadosProvider = UserProvider.getInstance();
    }    

    componentDidMount() {
        this.listarDocumentosRadio();
    }

    renderTipoDocumento(tipo) {
        let icon = "file";
        if (tipo === 'pdf') {
            icon = 'file-pdf';
        } else if (tipo === 'xls' || tipo === 'xlsx') {
            icon = 'file-excel';
        } else {
            icon = 'file';
        }

        return (
            <span>
                <Icon type={icon} style={{ marginRight: 8 }} />
                {tipo.toUpperCase()}
            </span>
        )
    }

    renderBtnBaixar(cdPessoaArquivo, dsNomeArquivo) {
        return (
            <a onClick={() => { this.baixarDocumento(cdPessoaArquivo, dsNomeArquivo) }}> Download!</a>
        )
    }

    renderObs(dados) {
        return (
            <div>
                {dados.dsObs.length >= 50 ?
                    <span onClick={() => { this.showModalObservacao(true, dados.dsObs) }}>
                        <span>Data de criação: {dados.dtOperacao}</span><br></br>
                        {dados.dsObs.substr(0, 50) + "... "}
                        <a>Ler tudo</a>
                    </span>
                    : 
                    <div>
                        <span>Data de criação: {dados.dtOperacao}</span><br></br>
                        <span>{dados.dsObs}</span>
                    </div>
                }
            </div>
        )
    }

    showModalObservacao(visibilidade, text) {
        this.setState({
            modalObservacaoShow: visibilidade,
            modalObservacaoText: text
        });
    }

    baixarDocumento(cdPessoaArquivo, dsNomeArquivo) {
        var dados = {
            "uiFilial": this.dadosProvider.getUiFilial(),
            "cripto": this.dadosProvider.getDadosUsuario().Cripto,
            "cdPessoaArquivo": cdPessoaArquivo,
            "dsNomeArquivo": dsNomeArquivo,
            "cdTipoOrigem": 5
        };

        this.setState({ loading: true });

        this.dataService.DownloadRadioDocumento(dados, (retorno) => {
            this.setState({ loading: false });
        }, (erro) => {
            console.error(erro);
            this.setState({ loading: false });
        });
        
    }

    listarDocumentosRadio() {
        var dados = {
            "uiFilial": this.dadosProvider.getUiFilial(),
            "cripto": this.dadosProvider.getDadosUsuario().Cripto,
            "cdTipoOrigem": 5
        };

        this.setState({ loading: true });

        this.dataService.GetListaRadioDocumentos(dados, (retorno) => {

            this.setState({ loading: false });

            if (retorno.length > 0) {
                var data = [];

                retorno.map((item) => {
                    data.push({
                        cdPessoaArquivo: item["CdPessoaArquivo"],
                        dsNomeArquivo: item["DsNomeArquivo"],
                        dsExtensao: item["DsExtensao"],
                        dsObs: item["DsObs"],
                        nrTamanho: item["NrTamanho"],
                        dtOperacao: item["DtOperacao"]
                    });
                });

                this.setState({ dadosTabelaDocumentos: data });
            }
        }, (erro) => {
            console.error(erro);
            this.setState({ loading: false });
        });
    }


    render() {

        return (
            <LayoutPages pageTitle="Documentos" pageLocation={this.props.location} history={this.props.history} pageIndex="5">
                <List
                    className="list-style"
                    bordered={true}
                    itemLayout="vertical"
                    dataSource={this.state.dadosTabelaDocumentos}
                    loading={this.state.loading}
                    renderItem={item => (
                        <List.Item
                            key={item.cdPessoaArquivo}
                            actions={[
                                <span>{this.renderTipoDocumento(item.dsExtensao)}</span>,
                                <span><Icon type="calculator" style={{ marginRight: 8 }} /> {item.nrTamanho}</span>,
                                <span><Icon type="download" style={{ marginRight: 8 }} /> {this.renderBtnBaixar(item.cdPessoaArquivo, item.dsNomeArquivo)}</span>
                            ]}
                        >
                            <List.Item.Meta
                                title={item.dsNomeArquivo}
                                description={this.renderObs(item)}
                            />
                        </List.Item>
                    )}
                />
                <Modal
                    title="Observação Completa"
                    visible={this.state.modalObservacaoShow}
                    onOk={() => { this.showModalObservacao(false) }}
                    onCancel={() => { this.showModalObservacao(false) }}
                    footer={[
                      <Button key="button" type="primary" onClick={() => { this.showModalObservacao(false) }}>
                        FECHAR
                      </Button>
                    ]}
                >
                    <p>{this.state.modalObservacaoText}</p>
                </Modal>
            </LayoutPages>
        )
    }
}

export default Documentos;


// WEBPACK FOOTER //
// ./src/Pages/Documentos/Documentos.js